import React from "react";
import { ApplicationHistory } from "./History/ApplicationHistory";
import { MoneticsHistory } from "@pages/Peripherals/Monetics/MoneticsHistory";
import OriginHistory from "@pages/Peripherals/Printers/OriginHistory";
import HistoryModal from "@pages/Peripherals/CashManagement/HistoryModal";

function HistoryApplication({
    selectedRows,
    isHistoryModalOpened,
    setIsHistoryModalOpened,
    setGlobalDataIsUpdated,
    isHistoryMoneticsModalOpened,
    setIsHistoryMoneticsModalOpened,
    isHistoryModalCashMangmentOpened,
    setIsHistoryModalCashMangmentOpened,
    isAddPrinterOriginHistoryClicked,
    urlHistoryPrinter,
    setIsAddPrinterOriginHistoryClicked,
    displayMode,
}: any) {
    return (
        <div>
            {isHistoryModalOpened ? (
                <ApplicationHistory
                    selectedRows={selectedRows}
                    isHistoryModalOpened={isHistoryModalOpened}
                    setIsHistoryModalOpened={setIsHistoryModalOpened}
                    setDataShopIsUpdated={setGlobalDataIsUpdated}
                    displayMode={displayMode}
                />
            ) : null}
            {isHistoryMoneticsModalOpened ? (
                <MoneticsHistory
                    selectedRows={selectedRows}
                    isHistoryModalOpened={isHistoryMoneticsModalOpened}
                    setIsHistoryModalOpened={setIsHistoryMoneticsModalOpened}
                    setGlobalDataUpdated={setGlobalDataIsUpdated}
                    displayMode={displayMode}
                />
            ) : null}
            {isHistoryModalCashMangmentOpened ? (
                <HistoryModal
                    isModalOpened={isHistoryModalCashMangmentOpened}
                    setIsModalOpened={setIsHistoryModalCashMangmentOpened}
                    setGlobalDataUpdated={setGlobalDataIsUpdated}
                />
            ) : null}
            {isAddPrinterOriginHistoryClicked && (
                <OriginHistory
                    url={urlHistoryPrinter}
                    setIsModalOpened={setIsAddPrinterOriginHistoryClicked}
                    isModalOpened={isAddPrinterOriginHistoryClicked}
                />
            )}
        </div>
    );
}

export default HistoryApplication;
